export const taskTypeIDs = {
  visit: 1,
  general: 2
}
